module.exports = __webpack_public_path__ + "static/media/trailz-groups.c9c42ab3.png";